import { styled } from "styled-components";

import Section from "components/Section";
import { Container } from "style/components/Page";
import { styleBodyM } from "style/components/Typography";
import { columnGap } from "style/grid";
import { MQ } from "style/mediaQueries";

export const BottomSection = styled(Section)`
    background-color: var(--block-blue-default);

    &::after {
        background-color: var(--overlay-on-blue-darken);
        content: "";
        inset: 0;
        position: absolute;
        z-index: 0;
    }
`;

export const BottomContainer = styled(Container)`
    ${columnGap};
    ${styleBodyM};
    display: grid;
    grid-auto-rows: min-content;
    grid-template-columns: repeat(4, [col-start] 1fr);
    padding-bottom: 1.3125rem;
    padding-top: 1.3125rem;
    place-items: center flex-start;
    position: relative;

    ${MQ.FROM_M} {
        grid-template-columns: repeat(12, [col-start] 1fr);
    }
`;

export const Links = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.875rem 1.75rem;
    grid-column: 1 / span 4;
    justify-self: center;
    z-index: 1;

    ${MQ.FROM_M} {
        flex-direction: row;
        grid-column: 1 / span 12;
        justify-self: center;
    }

    ${MQ.FROM_L} {
        align-items: flex-start;
        justify-self: flex-end;
        text-align: right;
    }
`;
